import script from "./CustomersGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomersGrid.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__